module.exports = __webpack_public_path__ + "img/fondo_transparent.e53eef66.png";